import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {ContestType, ContestTypeListResponse} from "../http/protocol";


export class ContestTypesService  extends AbstractAdminEntityService<ContestType, ContestTypeListResponse>  {

    constructor(http : HttpService) {
        super("/contest-types", http)
    }

}